import Timeline from '../sections/timeline/timeline';

export default function TimelinePage() {
  return <Timeline />;
}
